document.addEventListener("DOMContentLoaded", () => {

  const container =
    document.querySelector(".js-article-enhance") ||
    document.querySelector(".article-content, .rte");

  if (!container) return;

  const headings = container.querySelectorAll("h2");
  if (!headings.length) return;

  const indexBox = document.getElementById("article-index");
  if (!indexBox) return;

  const displayTitle = container.dataset.displayTitle || "";
  const prefix = container.dataset.numberPrefix || "";
  const digit = parseInt(container.dataset.numberFormat || 2);

  let list = document.createElement("ul");

  indexBox.innerHTML = `<p class="index-title en">index</p>`;
  indexBox.appendChild(list);

  headings.forEach((h2, i) => {
    const number = String(i + 1).padStart(digit, "0");
    const label = prefix + number;
    const id = `section-${number}`;

    const originalText = h2.textContent.trim();
    h2.id = id;

    if (!h2.querySelector(".article-h2-number")) {
      const numberEl = document.createElement("span");
      numberEl.className = "article-h2-number en";
      numberEl.textContent = label;
      h2.prepend(numberEl);
    }

    if (displayTitle) {
      if (!h2.previousElementSibling ||
          !h2.previousElementSibling.classList.contains("article-h2-pretitle")) {

        const wrapper = document.createElement("div");
        wrapper.className = "article-h2-pretitle";

        const inner = document.createElement("div");
        inner.className = "article-h2-pretitle__inner";
        inner.innerHTML = displayTitle.replace(/\n/g, "<br>");

        wrapper.appendChild(inner);
        h2.parentNode.insertBefore(wrapper, h2);
      }
    }

    const li = document.createElement("li");
    li.className = "article-index__item";

    const numberEl = document.createElement("span");
    numberEl.className = "article-index__number en";
    numberEl.textContent = label;

    const link = document.createElement("a");
    link.href = `#${id}`;
    link.setAttribute("data-anchor", "");
    link.className = "article-index__link";
    link.textContent = originalText;

    li.appendChild(numberEl);
    li.appendChild(link);
    list.appendChild(li);
  });

});